import React,{useState,useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getActivePrice } from "../../utils/converter";
import Cart from "../../assets/img/core-img/cart.png"
import Skeleton from 'react-loading-skeleton'


const ProductsSkeleton = ({cards}:any) => {



  return (
    <div className="row">
 {Array(cards).fill(0).map((d: any, index: number) => (

    <div className="col-12 col-sm-6 col-md-12 col-xl-6" key={index} >
        <div className="single-product-wrapper" >
            <div className="product-img">
                {/* <img src={d?.images[0]} alt=""/> */}
                <Skeleton width={398.5} height={398.5} />
                {/* <img className="hover-img" src="img/product-img/product2.jpg" alt=""> */}
            </div>

            <div className="product-description d-flex align-items-center justify-content-between">
                <div className="product-meta-data">
                    <div className="line"></div>
                    <p className="product-price"><Skeleton  /></p>
                    <a href="#">
                        <h6><Skeleton  /></h6>
                    </a>
                </div>
                <div className="ratings-cart text-right">
                    <div className="ratings">
                    <Skeleton  />
                    </div>
                    {/* <div className="cart" >
                     <a href="#" data-toggle="tooltip" data-placement="left" title="Add to Cart" onClick={() => handleAddToCart(d?._id)}>{isLoading ? (<small>saving...</small>): (<img src={Cart} alt="" />)}</a>
                    </div> */}
                </div>
            </div>
        </div>
    </div>

    ))}

    </div>

   
  );
};

export default ProductsSkeleton;
